import stateManager from './StateManager.mjs';

class ViewManager {
    constructor() {
        this.initialized = false;
        this.currentViewModule = null;
    }

    initialize() {
        if (this.initialized) return;
        
        this.setupEventListeners();
        this.setupStateSubscriptions();
        this.initialized = true;
        
        // Apply initial state
        this.applyViewMode();
        this.applyMapMode();
    }

    setupEventListeners() {
        // View mode buttons
        document.addEventListener('click', (e) => {
            if (e.target.matches('[data-view-mode]')) {
                e.preventDefault();
                const mode = e.target.dataset.viewMode;
                stateManager.setState({ viewMode: mode });
            }
            
            if (e.target.matches('[data-map-mode]')) {
                e.preventDefault();
                const mode = e.target.dataset.mapMode;
                stateManager.setState({ mapMode: mode });
            }
            
            if (e.target.matches('[data-mobile-toggle]')) {
                e.preventDefault();
                const currentState = stateManager.getState('mobileMenuOpen');
                stateManager.setState({ mobileMenuOpen: !currentState });
            }
        });
    }

    setupStateSubscriptions() {
        // Subscribe to view mode changes
        stateManager.subscribe('viewMode', (viewMode) => {
            this.applyViewMode();
            this.updateViewModeButtons();
        });

        // Subscribe to map mode changes
        stateManager.subscribe('mapMode', (mapMode) => {
            this.applyMapMode();
            this.updateMapModeButtons();
        });

        // Subscribe to mobile menu changes
        stateManager.subscribe('mobileMenuOpen', (isOpen) => {
            this.applyMobileMenuState();
        });
    }

    applyViewMode() {
        const viewMode = stateManager.getState('viewMode');
        const container = document.getElementById('vessel-display-container');
        
        if (!container) return;

        // Remove existing mode classes
        container.classList.remove('tiles-view', 'list-view');
        
        // Add current mode class
        container.classList.add(`${viewMode}-view`);
        
        // If we're on the maps page, re-render the vessel display
        if (stateManager.getState('currentPage') === 'maps') {
            this.refreshVesselDisplay();
        }
    }

    applyMapMode() {
        const mapMode = stateManager.getState('mapMode');
        
        // Trigger map mode change if map is available
        if (window.mapInstance && typeof window.mapInstance.setMapTypeId === 'function') {
            const googleMapType = mapMode === 'satellite' ? 'satellite' : 'roadmap';
            window.mapInstance.setMapTypeId(googleMapType);
        }
    }

    applyMobileMenuState() {
        const isOpen = stateManager.getState('mobileMenuOpen');
        const mobileMenu = document.getElementById('mobile-menu');
        const overlay = document.getElementById('mobile-menu-overlay');
        const toggleBtn = document.querySelector('[data-mobile-toggle]');
        
        if (mobileMenu) {
            mobileMenu.classList.toggle('active', isOpen);
        }
        
        if (overlay) {
            overlay.classList.toggle('active', isOpen);
        }
        
        if (toggleBtn) {
            toggleBtn.classList.toggle('active', isOpen);
            toggleBtn.setAttribute('aria-expanded', isOpen.toString());
        }
        
        // Prevent body scroll when menu is open
        document.body.classList.toggle('mobile-menu-open', isOpen);
    }

    updateViewModeButtons() {
        const viewMode = stateManager.getState('viewMode');
        
        document.querySelectorAll('[data-view-mode]').forEach(btn => {
            const btnMode = btn.dataset.viewMode;
            btn.classList.toggle('active', btnMode === viewMode);
        });
    }

    updateMapModeButtons() {
        const mapMode = stateManager.getState('mapMode');
        
        document.querySelectorAll('[data-map-mode]').forEach(btn => {
            const btnMode = btn.dataset.mapMode;
            btn.classList.toggle('active', btnMode === mapMode);
        });
    }

    refreshVesselDisplay() {
        // Re-trigger the vessel display rendering with current view mode
        if (this.currentViewModule && typeof this.currentViewModule.refreshDisplay === 'function') {
            this.currentViewModule.refreshDisplay();
        }
    }

    setCurrentViewModule(module) {
        this.currentViewModule = module;
    }
}

export const viewManager = new ViewManager();
export default viewManager;